module.exports = __webpack_public_path__ + "img/Banner-image-delivery.ea279c1d.jpg";